import styled from 'styled-components';

export const Container = styled.div`
  .onoffswitch {
    position: relative;
    width: 170px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  .onoffswitch-checkbox {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  .onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.$light_border};
    border-radius: 20px;
    margin-top: 12px;

    &.onoffswitch-disabled {
      opacity: 0.7;
    }
  }
  .onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
  }
  .onoffswitch-inner:before,
  .onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 15px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
  }
  .onoffswitch-inner:before {
    content: 'Todos segmentos';
    padding-left: 10px;
    background-color: ${(props) => props.theme.$success};
    color: ${(props) => props.theme.$white};
  }
  .onoffswitch-inner:after {
    content: 'Meus segmentos';
    padding-right: 10px;
    background-color: ${(props) => props.theme.$gray600};
    color: ${(props) => props.theme.$white};
    text-align: right;
  }
  .onoffswitch-switch {
    display: block;
    width: 18px !important;
    height: 18px !important;
    margin: 2.5px;
    background: ${(props) => props.theme.$white};
    position: absolute;
    top: 0;
    bottom: 0;
    right: 150px;
    border: 1px solid ${(props) => props.theme.$light_border};
    border-radius: 20px;
    transition: all 0.3s ease-in 0s;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
  }

  @keyframes s-ripple {
    0% {
      transform: scale(0);
    }
    20% {
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
  @keyframes s-ripple-dup {
    0% {
      transform: scale(0);
    }
    30% {
      transform: scale(1);
    }
    60% {
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
`;
